function Type(d,p,e){const t={description:d,__runtimeType:true};if(typeof p==='function'){t.check=p;t.default=e??null}else{const ex=e??p;t.default=ex;t.check=v=>{if(ex===null)return true;return typeof v===typeof ex}}return t};
function Generic(tp,pred,d){const f=(...args)=>{const t={description:d||'generic',__runtimeType:true,check:v=>pred(v,...args)};return t};f.__runtimeType=true;f.description=d;return f};
function FunctionPredicate(n,s,b){if(Array.isArray(s)&&b){const f=(...a)=>FunctionPredicate(n,b(...a));f.typeParamNames=s.map(p=>Array.isArray(p)?p[0]:p);f.description=n;f.__runtimeType=true;return f}const spec=typeof s==='function'?{}:s||{};return{description:n,params:spec.params||{},returns:spec.returns,returnContract:spec.returnContract||'assertReturns',check:v=>typeof v==='function',__runtimeType:true}};
const __tjs = globalThis.__tjs?.createRuntime?.() ?? {Type,Generic,FunctionPredicate};
/* tjs <- make-component.ts */

/*#
# makeComponent

`makeComponent(tag: string, bluePrint: XinBlueprint<T>): Promise<XinComponentSpec<T>>`
hydrates [blueprints](/blueprint-loader/) into usable [web-components](/component/).

Here are the relevant interfaces:

```
export interface PartsMap<T = Element> {
  [key: string]: T
}

export type XinBlueprint<T = PartsMap> = (
  tag: string,
  module: XinFactory
) => XinComponentSpec<T> | Promise<XinComponentSpec<T>>

export interface XinComponentSpec<T = PartsMap> {
  type: Component<T>
  lightStyleSpec?: XinStyleSheet
  styleSpec?: XinStyleSheet // deprecated, use lightStyleSpec
}
```

Note that a crucial benefit of blueprints is that the **consumer** of the blueprint gets
to choose the `tagName` of the custom-element.
*/

import { Color } from './color'

import { Component } from './component'

import { vars, varDefault } from './css'

import { XinStyleSheet } from './css-types'

import { bind, on } from './bind'

import { elements, svgElements, mathML } from './elements'

import { ElementCreator, PartsMap } from './xin-types'

import { version } from './version'

import { xin, boxed } from './xin'

import { xinProxy, tosi, boxedProxy } from './xin-proxy'

export const XinFactory = Type('XinFactory', undefined, { Color: undefined, Component: undefined, elements: undefined, svgElements: undefined, mathML: undefined, vars: undefined, varDefault: undefined, xin: undefined, boxed: undefined, xinProxy: undefined, boxedProxy: undefined, tosi: undefined, makeComponent: undefined, bind: undefined, on: undefined, version: '' })

export const XinComponentSpec = Generic([['T', null]], (() => {let __f = 0;const __fuel = () => { if (--__f < 0) throw new RangeError('tjs:predicate-fuel'); };function __pred_XinComponentSpec(x, checkT) {__fuel(); return typeof x === 'object' && x !== null && 'type' in x && 'lightStyleSpec' in x && 'styleSpec' in x }return (...__a) => {__f = 1000000;try { return !!__pred_XinComponentSpec(...__a); }catch (e) {if (e instanceof RangeError && /tjs:predicate-fuel|stack/i.test(e.message)) return false;throw e;}};})(), 'XinComponentSpec')

export const XinPackagedComponent = Generic([['T', null]], (() => {let __f = 0;const __fuel = () => { if (--__f < 0) throw new RangeError('tjs:predicate-fuel'); };function __pred_XinPackagedComponent(x, checkT) {__fuel(); return typeof x === 'object' && x !== null && 'type' in x && 'creator' in x }return (...__a) => {__f = 1000000;try { return !!__pred_XinPackagedComponent(...__a); }catch (e) {if (e instanceof RangeError && /tjs:predicate-fuel|stack/i.test(e.message)) return false;throw e;}};})(), 'XinPackagedComponent')

export const madeComponents = {};

export const XinBlueprint = FunctionPredicate('XinBlueprint', [['T', null]], (T) => ({ params: { tag: '', module: null }, returns: null }))

/* line 80 */
export async function makeComponent(tag,blueprint) {
    const spec = (await blueprint(tag, {
        Color,
        Component,
        elements,
        svgElements,
        mathML,
        varDefault,
        vars,
        xin,
        boxed,
        xinProxy,
        boxedProxy,
        tosi,
        makeComponent,
        bind,
        on,
        version,
    }));
    const { type } = spec;
    type.preferredTagName = tag;
    const lightStyle = spec.lightStyleSpec ?? spec.styleSpec;
    if (lightStyle) {
        type.lightStyleSpec = lightStyle;
    }
    const packagedComponent = {
        type,
        creator: type.elementCreator(),
    };
    madeComponents[tag] = packagedComponent;
    return packagedComponent;
}
makeComponent.__tjs = {
  "params": {
    "tag": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    },
    "blueprint": {
      "type": {
        "kind": "any"
      },
      "required": true,
      "default": null
    }
  },
  "unsafe": true,
  "source": "make-component.ts:63"
}